<template>
    <div>
        <div class="app-body">
            <page-header></page-header>
            <div class="allContain">
                <nav-bar/>
                <div class="accountSet">
                    <h3 class="title">我的课程</h3>
                    <el-tabs v-model="currentTab" class="course-tabs">
                        <el-tab-pane :name="tab.value" v-for="tab in TABS_LIST" :key="tab.value">
                            <span slot="label" class="font-size16">{{tab.label}}</span>
                            <course-item :course="course"
                                         style="padding: 0 30px 30px 30px"
                                         v-for="course in courses[currentTab]"
                                         @start-study="onStartStudy"
                                         :key="course.Id"/>
                            <pagination :p-size.sync="paginationMap[currentTab].pageSize"
                                        :page-no.sync="paginationMap[currentTab].pageIndex"
                                        @change="getCourseList"
                                        :total="paginationMap[currentTab].total"/>
                            <el-empty description="暂无课程" v-if="courses[currentTab].length === 0"/>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>
        <bottom-ground></bottom-ground>
    </div>
</template>

<script>
import BottomGround from "@/components/bottomnav";
import PageHeader from "@/components/header";
import NavBar from "@/components/personCenter/nav";
import CourseItem from "@/views/course/cpns/CourseItem";
import pagination from "@/components/Pagination";
import { getCourseList } from "@/api/student-course"
import { TABS_LIST, getInitCourseList, getInitPagination } from "./config"
export default {
    components: {
        BottomGround,
        PageHeader,
        NavBar,
        CourseItem,
        pagination
    },
    created() {
        TABS_LIST.forEach(item => {
            getCourseList({
                IsMy: 1,
                LeanState: parseInt(item.value),
                ...this.paginationMap[item.value],
                total: undefined
            }).then(res => {
                this.courses[item.value] = res.data
                this.paginationMap[item.value].total = res.count
            })
        })
    },
    data() {
        return {
            pageIndex: 1,
            pageSize: 10,
            total: 10,
            courses: getInitCourseList(),
            paginationMap: getInitPagination(),
            currentTab: "2",
            TABS_LIST
        };
    },
    methods: {
        // 获取问卷列表
        getCourseList() {
            const { pageSize, pageIndex } = this.paginationMap[this.currentTab]
            getCourseList({
                pageSize,
                pageIndex,
                IsMy: 1,
                LeanState: parseInt(this.currentTab)
            }).then(res => {
                this.courses[this.currentTab] = res.data
                this.paginationMap[this.currentTab].total = res.count
            })
        },
        // 监听开始学习
        // 开始学习
        onStartStudy(course) {
            this.$router.push({
                path: "/course-play",
                query: {
                    SourceId: course.SourceId,
                    TimeNum: course.TimeNum
                }
            })
        }
    },
};
</script>

<style lang="less" scoped>
::v-deep .questionnaire-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto;
    padding: 0 30px 30px;
    // 间隙
    grid-gap: 30px;
}

.allContain {
    width: 100%;
    margin: 20px auto 30px;
    display: flex;
    justify-content: space-between;

    .accountSet {
        width: 940px;
        min-height: 830px;
        background-color: #fff;
        border-radius: 16px;
    }
}

.title {
    margin: 0;
    padding: 0 30px;
    height: 80px;
    line-height: 80px;
    font-size: 16px;
}
.course-tabs {
    padding: 0 30px;
}

</style>
